import React from 'react'
import {
  FormControl, InputLabel, Select, MenuItem, Grid, TextField, Box, Button,
  Typography, Container, OutlinedInput, InputAdornment, Tooltip, Link,
  Accordion, AccordionSummary, AccordionDetails, IconButton, Input, Paper
} from '@mui/material';
import { Chip } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { BorderColor } from '@mui/icons-material';
import axiosInstance from '../../lib/axios';
import Flag from '../../Components/Ragistration/Booking/Flag';
import moment from 'moment';
import BokingCModal from '../../Components/Ragistration/BConfirmation/BokingCModal';
import AccountGModal from '../../Components/Ragistration/BConfirmation/AccountGModal';
import { useReactToPrint } from 'react-to-print';
import BReport from '../../atoms/ReportFolder/BReport';
import axiosInstanceForPG from '../../lib/axiosFormPG';
import CircularProgress from '@mui/material/CircularProgress';
import 'jspdf-autotable';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ConfirmationDialog from '../ReusableDailog';
import EmailIcon from '@mui/icons-material/Email';
import { useSelector } from 'react-redux';
import { selectGlobalProperty ,selectGatewayType} from '../../redux/propertySlice';
import CancelIcon from '@mui/icons-material/Cancel';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CheckinArtical from '../CheckinArtical';
import PrintIcon from '@mui/icons-material/Print';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import CheckinArticalPrint from './CheckinArticalPrint';

const columns = [
  { id: 'BookId', label: 'BookId', minWidth: 50 },
  { id: 'BookNo', label: 'Booking No', minWidth: 120 },
  { id: 'BookDt', label: 'Book Date', minWidth: 130 },
  { id: 'BookSt', label: 'Status', minWidth: 130 },
  { id: 'ResidentName', label: 'Resident', minWidth: 130 },
  { id: 'MobileNo', label: 'Mobile', minWidth: 150 },
  { id: 'Duration', label: 'Duration', minWidth: 100 },
  { id: 'CheckinDt', label: 'CheckIn', minWidth: 100 },
  { id: 'CheckoutDt', label: 'CheckOut', minWidth: 100 },
];

function Checkoutartical(bookSt, onConfirm, bookId, onAccDetails, onAccGenerate) {
  const { register, watch, setValue, reset } = useForm();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [OpenLoader, setOpenLoader] = useState(false);
  const [TransactionData, setTransactionData] = useState([]);
  const [OpenHistoryTableDialog, setOpenHistoryTableDialog] = useState(false);
  const [AccGenerate, setAccGenerate] = useState(false);
  const [BookId, setBookId] = useState(-1);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [searchTerms, setSearchTerms] = useState({});
  const [activeView, setActiveView] = useState('advice');
  const [Mode, setMode] = useState('add');
  const [loadingPaymentLinks, setLoadingPaymentLinks] = useState({});
  const location = useLocation();
  // const contentRef = useRef(null);
  const contentRef = useRef(null);
  const [hasUnpaidRent, setHasUnpaidRent] = useState(false);
  const [switchState, setSwitchState] = useState(false);
  const [emailResponse, setEmailResponse] = useState(null);
  const [isBookingConfirmed, setIsBookingConfirmed] = useState(false);
  const [isDepositPaid, setIsDepositPaid] = useState(false);
  const [openCheckoutConfirm, setOpenCheckoutConfirm] = useState(false);
  const [openCheckinConfirm, setOpenCheckinConfirm] = useState(false);
  const handlePrint = useReactToPrint({ contentRef });
  const globalProperty = useSelector(selectGlobalProperty);
  const [showPayAdvice, setShowPayAdvice] = useState(false);
  const baseUrl = window.location.origin;
  const [payAdvice, setPayAdvice] = useState([]);
  const [isCheckoutProcessing, setIsCheckoutProcessing] = useState(false);
  const [selectedCheckoutDate, setSelectedCheckoutDate] = useState(new Date().toLocaleDateString('en-GB'));
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [accountData, setAccountData] = useState([]);
  const [oldBedId, setOldBedId] = useState('');
  const [residentid, setResidentId] = useState(null);
  const [propId, setPropId] = useState(null);
  const [selectedData, setSelectedDate] = useState(new Date().toLocaleDateString('en-GB'));
  const [minCheckInDate, setMinCheckInDate] = useState(null);
  const [openCheckoutList, setOpenCheckoutList] = useState(false);
  const [checkinArticalData, setCheckinArticalData] = useState(null);

  const [damageStatus, setDamageStatus] = useState({});
  const [damageCharges, setDamageCharges] = useState({});
  const [lostCharges, setLostCharges] = useState({});
  const [remarks, setRemarks] = useState({});
  const [uploadedPhotos, setUploadedPhotos] = useState({});
  const gatewayType = useSelector(selectGatewayType);

  useEffect(() => {
    if (BookId !== -1 && !isCheckoutProcessing) {
      fetchPayAdvice(BookId);
    }
  }, [BookId, isCheckoutProcessing]);

  useEffect(() => {
    // let MobileNo = location.state?.MobileNo;
    let BookId = location?.state?.BookId
    if (BookId) {
      // handleMobileChange(MobileNo, "B");
      fetchTransactionData(BookId);
    } else {
      setMode("add");
    }
    const fetchApi = async () => {
      setValue("CountryIcon", Flag);
      setValue("BookDt", "");
      setValue("BookDtFrom", "");
      setValue("BookUpToDt", "");
      // await fetchDataOfBooking();
    };
    fetchApi();
  }, [location.state?.BookId]);

  const fetchTransactionData = async (bookId) => {
    if (!bookId) return;

    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`TrnBooking/RetriveTrnBooking`, {
        BookId: bookId,
        Flag: "R",
        CreatedBy: UserId
      }
      );

      if (response.data.Status === 0) {
        setIsDataLoaded(true);
        const bookingData = response.data.Data[0];
        const {
          BookSt, PropId, ResidentId, RoomBedId, CheckedOutDt, MobileNo, ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, CheckoutDt,
          TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, CheckinDt, CheckingDt, Email, PlanName, MonthlyAmt, BookStatus
        } = bookingData;
        setAccountData(bookingData);
        setOldBedId(RoomBedId);
        setResidentId(ResidentId);
        setPropId(PropId);
        setBookId(bookId);
        setValue("MobileNo", MobileNo);
        setValue("ResidentName", ResidentName);
        setValue("BookNo", BookNo);
        setValue("BookDt", BookDt);
        setValue("Duration", Duration);
        setValue("BookDtFrom", BookDtFrom);
        setValue("BookUpToDt", BookUpToDt);
        setValue("CheckoutDt", CheckoutDt);
        setValue("TopupAmt", TopupAmt);
        setValue("AdvcRcble", AdvcRcble);
        setValue("DiscAmt", DiscAmt);
        setValue("TotalRent", TotalRent);
        setValue("NetAmt", NetAmt);
        setValue("BedRent", BedRent);
        setValue("FreeMonth", FreeMonth);
        setValue("PropName", PropName);
        setValue("Email", Email);
        setValue("PlanName", PlanName);
        setValue("MonthlyAmt", MonthlyAmt);
        setValue("CheckinDt", CheckinDt)
        setValue('CheckedOutDt', CheckedOutDt)
        setValue('CheckingDt', CheckingDt)
        if (BookSt === "C") {
          setSelectedDate(CheckinDt);
        } else {
          const currentDate = new Date().toISOString()?.split("T")[0];
          const bookFromDateObj = new Date(BookDtFrom);
          const currentDateObj = new Date(currentDate);
          bookFromDateObj.setHours(0, 0, 0, 0);
          currentDateObj.setHours(0, 0, 0, 0);
          setSelectedDate(currentDateObj >= bookFromDateObj ? currentDate : BookDtFrom);
        }

        setMinCheckInDate(BookDtFrom);
        setAccGenerate(BookSt === "B");
        setTransactionData(response.data.Data);
        await fetchPayAdvice(bookId);
        await fetchRoomBedData(RoomBedId, BookDtFrom, BookUpToDt, PropId);
        await fetchServicesData(bookingData.TransPlanId, bookingData.MessPlanId);
      } else {
        setIsDataLoaded(false);
        toast.info("Booking Not Found");
        resetFuncM();
      }
    } catch (error) {
      toast.error("Failed to load booking data");
    } finally {
      setOpenLoader(false);
    }
  };

  const fetchPayAdvice = async (BookId) => {
    console.log("Fetching payment advice for BookId:", BookId);
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        "PytAdvDt": moment().format("YYYY-MM-DD"),
        "Flag": "GenPytAdv",
        "BookId": BookId
      });

      if (response.data.Status === 0) {
        setPayAdvice(response.data.Data);
        setShowPayAdvice(true);

        const unpaidRentExists = response.data.Data.some(
          item => item.PytAdvFor === "R" && item.IsDepPaid !== "Y"
        );
        const firstInstallmentPaid = response.data.Data.some(
          item => item.PytAdvFor === "R" &&
            item.Remark?.includes("Installment 1") &&
            item.IsDepPaid === "Y"
        );

        setHasUnpaidRent(unpaidRentExists && !firstInstallmentPaid);
      }
    } catch (error) {
      toast.error('Error fetching payment advice:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  useEffect(() => {
    if (TransactionData.length > 0) {
      const { MobileNo, ResidentName, CheckinDt, BookNo, CheckingDt, CheckoutDt, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, BookId, PropName, Email, PropId } = TransactionData[0];
      let obj = { ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, MobileNo, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, Email, CheckinDt, PropId }

      setValue("MonthlyAmt", Math.round(NetAmt / Duration));
      setObjValue(obj);
      setValue("Email", Email);
      setValue("PropId", PropId);
      setValue("CheckinDt", CheckinDt)
      setValue('CheckingDt', CheckingDt)
      setBookId(BookId)
      const fetchDataAndSet = async () => {
        await fetchRoomBedData(TransactionData[0].RoomBedId, TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, TransactionData[0].PropId);
        await fetchPlanData(TransactionData[0].RoomPlanId);
        await fetchServicesData(TransactionData[0].TransPlanId, TransactionData[0].MessPlanId);
      }
      fetchDataAndSet();
      setNetAmount();
    }
  }, [TransactionData, globalProperty]);

  useEffect(() => {
    const today = dayjs();
    const formattedToday = today.format('DD/MM/YYYY');
    setValue('CheckoutDt', formattedToday);
    setSelectedCheckoutDate(formattedToday);
  }, []);

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filteredRows = React.useMemo(() => {
    return rows.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, rows]);

  const fetchDataOfBooking = async () => {
    try {
      const response = await axiosInstance.post(
        `TrnBooking/GetTrnBookingDashBoard`,
        {
          PageNumber: 1,
          PageSize: 1,
          SearchText: '',
          Flag:'PendChkArt',
          MobileNo :'',
          BookNo:'',
          PropId:globalProperty,
        }
      );

      if (response.data.Status === 0) {
        const formattedData = response.data.Data.map(checkout => ({
          ...checkout,
          BookSt: checkout.BookSt === "O" ? "CheckedIn" : checkout.BookSt === "X" ? "Cancel" : ""
        }));
        setRows(formattedData);
      } else {
        toast.error('Error fetching Grid data:', response.data.Message);
        setRows([]);
      }
    } catch (error) {
      toast.error('Error fetching Booking data:', error);
    }
  };

  const handleMobileChange = async (e, Separator) => {
    let val = "";
    if (Separator === "A") {
      val = e.target.value.trim()
    } else {
      val = e.trim();
    }

    if (val.length >= 10) {
      try {
        const response = await axiosInstance.post(
          `TrnBooking/GetTrnBookingDashBoard`,
          {
            "start": 1,
            "PageSize": 1,
            "SearchText": 'PendChkArt',
            "Flag":'',
            "MobileNo" :val,
            "BookNo":'',
            "PropId":1,
          }
        );

        if (response.data.Status === 0) {
          setIsDataLoaded(true);
          const { BookSt, IsDepPaid } = response.data.Data[0];
          const data = response.data.Data[0]
          setAccountData(data);
          setIsDepositPaid(IsDepPaid === "Y");
          setIsBookingConfirmed(BookSt === "O");
          setSwitchState(BookSt === "O");
          if (BookSt === "B") {
            setAccGenerate(false);
          } else {
            setAccGenerate(true);
          }
          setTransactionData(response.data.Data);
          await fetchPayAdvice(response.data.Data[0].BookId);
        } else {
          setIsDataLoaded(false);
          toast.info("Booking Doesn't Exist On This Number");
          resetFuncM();
          setValue("BookNo", "");
          setBookId(-1);
        }
      } catch (error) {
        toast.error('Error fetching data:', error);
      }
    } else if (val.length === 9) {
      resetFuncM();
      setValue("BookNo", "");
      setBookId(-1);
    }
    Separator === "B" && handleClose();
  };

  const handleBookNoChange = async (e, Separator) => {
    let val = "";
    if (Separator === "A") {
      val = e.target.value.trim()
    } else {
      val = e.trim();
    }

    if (val.length >= 8) {
      try {
        const response = await axiosInstance.post(
          `TrnBooking/GetTrnBookingDashBoard`,
          {
            "start": 1,
            "PageSize": 1,
            "SearchText": 'PendChkArt',
            "Flag":'',
            "MobileNo" :'',
            "BookNo":val,
            "PropId":1,
          }
        );

        if (response.data.Status === 0) {
          setIsDataLoaded(true);
          const { BookSt, IsDepPaid } = response.data.Data[0];
          setIsDepositPaid(IsDepPaid === "Y");
          setIsBookingConfirmed(BookSt === "O");
          setSwitchState(BookSt === "O");

          if (BookSt === "B") {
            setAccGenerate(true);

          } else {
            setAccGenerate(false);
          }
          setTransactionData(response.data.Data);
          await fetchPayAdvice(response.data.Data[0].BookId);
        } else {
          toast.info("Booking Doesn't Exist On This Number");
          resetFuncM();
          setValue("MobileNo", "");
          setBookId(-1);
        }
      } catch (error) {
        toast.error('Error fetching Booking data:', error);
      }
    } else if (val.length === 7) {
      setIsDataLoaded(false);
      resetFuncM();
      setValue("MobileNo", "");
    }
    Separator === "B" && handleClose();
  }

  const fetchRoomBedData = async (RoomBedId, date1, date2, PropId) => {
    try {
      const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
        BookFromDt: date1,
        BookToDt: date2,
        PropId: PropId,
        Flag: "",
        RoomBedId: RoomBedId
      });

      if (response.data.Status === 0) {
        handleRowDoubleClick(response.data.Data[0]);
      }
    } catch (error) {
      toast.error('Error fetching company data:', error);
    }
  };

  const fetchPlanData = async (PlanId) => {
    try {
      const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
        "RoomPlanID": PlanId,
        "Flag": "R"
      });

      if (response.data.Status === 0) {
        setPlanData(response.data.Data);
      }
    } catch (error) {
      toast.error('Error fetching company data:', error);
    }
  };

  const handleRowDoubleClick = async (row) => {
    const { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, } = row;
    const obj = { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, };
    setObjValue(obj);
  };

  const setPlanData = (PlanArr) => {
    const { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt } = PlanArr[0];
    const obj = { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt };
    setObjValue(obj);
  }


  const setObjValue = (obj) => {
    for (let key in obj) {
      setValue(key, obj[key]);
    }
  }

  const handleClose = () => {
    setOpenHistoryTableDialog(false);
    setPage(0);
    setTimeout(() => {
      setSearchTerms({});
    }, [500]);

  };

  const handleClickCheckAva = async () => {
    await fetchDataOfBooking();
    setOpenHistoryTableDialog(true);
  };

  const setNetAmount = () => {
    setValue("TotalAmt", ((watch("TAmount") || 0) + (watch("MAmount") || 0) + (watch("TopupAmt") || 0) + (watch("AdvcRcble") || 0)));
  };

  const fetchServicesData = async (TransPlanId, MessPlanId) => {
    const Flag = "";
    try {
      const response = await axiosInstance.post(
        `MstTransPlan/getMstTransPlandrp`,
        { Flag, UserId },
      );

      if (response.data.Status === 0) {
        // setTransPlanDrp(response.data.Data);
        let obj = response.data.Data.find(obj => obj.TransPlanID === TransPlanId);
        if (obj) {
          setValue("TAmount", obj.Amount);
        } else {
          setValue("TAmount", 0);
        }
        setNetAmount()
      } else {
        toast.error('Error fetching Trans data');
      }
    } catch (error) {
      toast.error('Error fetching property data');
    }
    try {
      const response = await axiosInstance.post(
        `MstMessPlan/getMstMessPlandrp`,
        { Flag, UserId },
      );

      if (response.data.Status === 0) {

        let obj = response.data.Data.find(obj => obj.MessPlanID === MessPlanId);
        if (obj) {
          setValue("MAmount", obj.Amount);
        } else {
          setValue("MAmount", 0);
        }
        setNetAmount();
      } else {
      }
    } catch (error) {
      toast.error('Error fetching Plan data');
    }
  }
  const resetFuncM = () => {
    const obj = {
      "ResidentName": "",
      "BookDt": "",
      "Duration": "",
      "BookDtFrom": "",
      "BookUpToDt": "",
      "WingName": "",
      "FloorName": "",
      "RoomTypeName": "",
      "RoombedName": "",
      "RoomBedTypeName": "",
      "BedRent": "",
      "PlanName": "",
      "PlanTenur": "",
      "FreeMonth": "0",
      "LastAdjMonths": "0",
      "IncRentPerc": "",
      "DepositAmt": "",
      "TopupAmt": "",
      "Tamt": "",
      "MAmount": "",
      "TAmount": "",
      "TotalRent": "",
      "DiscAmt": "",
      "NetAmt": "",
      "MonthlyAmt": "",
      "PropName": "",
    }
    for (let key in obj) {
      setValue(key, "")
    }
    setValue("CountryIcon", Flag);

  };

  const handleCheckoutConfirm = async () => {
    setOpenLoader(true);
    setOpenCheckoutConfirm(false);
    setIsCheckoutProcessing(true);

    try {
      const checkoutDate = watch('CheckedOutDt');
      const formattedDate = dayjs(checkoutDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
      const response = await axiosInstance.post(
        `TrnBooking/TrnBookingConfirmation`,
        {
          "BookId": BookId,
          "CreatedBy": UserId,
          "Flag": "L",
          // "CreatedDate": TransactionData[0].CheckoutDt
          "CreatedDate": formattedDate,
        },
      );

      if (response.data.Status === 0) {
        toast.success("CheckOut Successfully");
        setTransactionData(prevData =>
          prevData.map(item => ({
            ...item,
            BookSt: "L"
          }))
        );
        setSwitchState(false);
        setIsBookingConfirmed(false);
      } else {
        toast.error(response.data.Message || "Operation failed");
      }
    } catch (error) {
      toast.error('Error fetching CheckIn data');
    } finally {
      setOpenLoader(false);
      setIsCheckoutProcessing(false);
    }
  };

  const handleClickCancel = () => {
    navigate("/checkout/checkoutarticaltable");
  }


  const handleCheckInClick = () => {
    if (BookId === -1) {
      toast.info("Nothing Any Transaction Is Visible");
      return;
    }

    setOpenCheckinConfirm(true);
  };

  const handleCheckinConfirm = async () => {
    setOpenLoader(true);
    setOpenCheckinConfirm(false);

    try {
      const response = await axiosInstance.post(
        `TrnBooking/TrnBookingConfirmation`,
        {
          "BookId": BookId,
          "CreatedBy": UserId,
          "Flag": "O"
        },
      );

      if (response.data.Status === 0) {
        toast.success("Checkout Cancel Successfully");
        setTransactionData(prevData =>
          prevData.map(item => ({
            ...item,
            BookSt: "O"
          }))
        );
        setSwitchState(true);
        setIsBookingConfirmed(true);

        await fetchPayAdvice(BookId);

      } else {
        toast.error(response.data.Message || "Operation failed");
      }
    } catch (error) {
      toast.error('Error fetching CheckIn data');
    } finally {
      setOpenLoader(false);
    }
  };

  const formatDate = (date) => {
    if (!date || !moment(date).isValid()) return '';
    return moment(date).format('DD/MM/YYYY');
  };

  const handleSendPaymentLink = async (item) => {
    try {
      setIsLoading(true);
      setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: true }));
      const userId = parseInt(sessionStorage.getItem('UserId'));
      const paymentDetails = {
        customer_details: {
            customer_email: item.Email || "",
            customer_name: item.ResidentName, 
            customer_phone: item.MobileNo
        },
        link_amount: parseFloat(item.Amount) || 0,
        link_auto_reminders: true,
        link_currency: "INR",
        link_expiry_time: "2026-06-09T15:04:05+05:30",
        link_id: "Testing9062026",
        link_meta: {
            notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
            return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
            upi_intent: false
        },
        link_minimum_partial_amount: parseFloat(item.Amount),
        link_notes: {
            key_1: "CashFreepay",
            key_2: "linkCashfree"
        },
        link_notify: {
            send_email: false,
            send_sms: true
        },
        link_partial_payments: false,
        link_purpose: item.Remark,
        ResidentId: item.ResidentId,
        Flag: "Active",
        Remark: "Testing",
        TrjType: "TrnPytAdv",
        TrjDocNo: item.PytAdvNo,
        TrjDocId: item.BookId,
        cf_payment_id: "",
        payment_status: ""
    };

      const response = await axiosInstanceForPG.post(
        `PaymentGatewayLog/CreateCashFreeLink`,
        paymentDetails,
      );

      if (response.data.Status == 0) {
        return toast.success(response.data.Message);
      }

      let paymentResponse = response.data;
      if (typeof paymentResponse === 'string') {
        paymentResponse = JSON.parse(paymentResponse);
      }
      setEmailResponse(paymentResponse.link_url);
      const paymentLogPayload = {
                id: paymentResponse.link_id,
                cf_link_id: paymentResponse.cf_link_id,
                phone: paymentResponse.customer_details.customer_phone,
                email: paymentResponse.customer_details.customer_email,
                buyer_name: paymentResponse.customer_details.customer_name || 'null',
                amount: paymentResponse.link_amount,
                purpose: paymentResponse.link_purpose,
                expires_at: null,
                status: paymentResponse.link_status,
                send_sms: paymentResponse.link_notify.send_sms,
                send_email: paymentResponse.link_notify.send_email,
                sms_status: 'null',
                email_status: 'null',
                shorturl: 'null',
                longurl: paymentResponse.link_url,
                redirect_url: paymentResponse.link_meta.return_url,
                webhook: 'null',
                allow_repeated_payments: true,
                created_at: paymentResponse.link_created_at,
                modified_at: paymentResponse.link_created_at,
                ResidentId: item.ResidentId,
                link_qrcode: paymentResponse.link_qrcode,
                TrjDocNo: item.PytAdvNo,
                TrjDocId: item.PytAdvId,
                TrjType: "TrnPytAdv",
                Flag: "Active",
                Remark: "Payment Link for Payment Advice",
                Gatewaytype: "CashFree",
            };
      await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload);

      const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${item.PytAdvNo}]`;
        const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentResponse.link_id}`;
      const Body = `Hey <strong>${item.ResidentName}</strong>,<br><br>
            We would like to inform you that payment advice has been created for you tenancy at <strong>${item.PropName}</strong>.Please find attached your payment advice with this email <br><br>
            Following are the details : <br><br>
            Advice No: <strong>${item.PytAdvNo}</strong><br>
            Amount: <strong>${item.Amount}</strong><br>
            Date Of Issue: <strong>${formatDate(item.PytAdvDt)}</strong><br>
            Due Date: <strong>${formatDate(item.DueDt)}</strong><br>
            <strong>Payment Link:</strong> <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
            We hope you are having a pleasant stay with us. Do let us know if you need any assitance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
            Cheers,<br>
            Team Clanbridge`;

      const emailRequest = {
        ToEmail: item.Email ? [item.Email] : [],
        Subject,
        Body,
        Attachments: '',
        attachmentFilePaths: [],
        PropId: item.PropId,
        UserId: userId,
      };
      const emailResponse = await axiosInstanceForPG.post(
        `EmailRequest/SendEmail`,
        emailRequest,
      );

      if (emailResponse.data.Status === 0) {
        toast.success(`Payment Link Sent Successfully for ${item.PytAdvNo}`);
      } else {
        toast.info(emailResponse.data.Message);
      }
      fetchPayAdvice(activeView === 'advice' ? 'GenPytAdv' : 'BookingWise');
    } catch (error) {
      toast.error("Failed to send payment link");
    } finally {
      setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
      setIsLoading(false);
    }
  };

  const handleCheckList = () => {
    if (BookId === -1) {
      toast.info("No booking selected");
      return;
    }

    if (!TransactionData.length || !TransactionData[0]?.RoomTypeId || !TransactionData[0]?.RoomBedTypeId) {
      toast.info("Room information not available");
      return;
    }

    setOpenCheckoutList(true);
  };
  const fetchCheckinArticalData = async () => {
    try {
      const response = await axiosInstance.post(`TrnChkArticle/RetriveTrnChkArt`, {
        BookId: BookId,
        RoomTypeId: TransactionData[0]?.RoomTypeId,
        RoomBedTypeId: TransactionData[0]?.RoomBedTypeId,
        Flag: "TrnChkOut"
      });

      if (response.data.Status === 0 && response.data.Data && response.data.Data.TrnChkArtList) {
        const items = response.data.Data.TrnChkArtList;

        const initialDamageStatus = {};
        const initialDamageCharges = {};
        const initialLostCharges = {};
        const initialRemarks = {};
        const initialUploadedPhotos = {};

        items.forEach((mainItem, mainIndex) => {
          if (mainItem.TrnChkArtList && mainItem.TrnChkArtList.length > 0) {
            mainItem.TrnChkArtList.forEach((article) => {
              const articleKey = `${mainIndex}-${article.ChkArticleId}`;
              initialDamageStatus[articleKey] = article.Status || 'O';
              initialDamageCharges[articleKey] = article.DmzChrg || 0;
              initialLostCharges[articleKey] = article.StdRate || 0;
              initialRemarks[articleKey] = article.ArtRemk2 || '';

              if (article.ArtImg2) {
                initialUploadedPhotos[articleKey] = article.ArtImg2.replace('http:/', 'http://');
              }
            });
          }
        });

        setDamageStatus(initialDamageStatus);
        setDamageCharges(initialDamageCharges);
        setLostCharges(initialLostCharges);
        setRemarks(initialRemarks);
        setUploadedPhotos(initialUploadedPhotos);

        setCheckinArticalData({
          items: items,
          bookingData: {
            BookNo: watch('BookNo'),
            ResidentName: watch('ResidentName'),
            RoombedName: watch('RoombedName'),
            CheckinDt: watch('CheckinDt'),
            PropName: watch('PropName'),
            MobileNo: watch('MobileNo'),
            Email: watch('Email'),
            Duration: watch('Duration'),
            BookDtFrom: watch('BookDtFrom'),
            BookUpToDt: watch('BookUpToDt')
          }
        });
      }
    } catch (error) {
      toast.error('Failed to load check-in articles data');
    }
  };


  return (
    <>
      <Box className="form-container">
        <ToastContainer />
        <BokingCModal OpenHistoryTableDialog={OpenHistoryTableDialog} handleClose={handleClose} columns={columns} TextField={TextField} handleSearchChange={handleSearchChange} filteredRows={filteredRows} page={page} rowsPerPage={rowsPerPage} handleMobileChange={handleMobileChange} handleBookNoChange={handleBookNoChange} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />
        <Grid container spacing={3} className="rasidant_grid" >
          <Container maxWidth="lg" spacing={1} justifyContent="center" alignItems="center">
            <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
              <Typography variant="h5" align="center">
                Check-Out & Handover
              </Typography>

              <Box sx={{ position: 'absolute', right: 0, display: 'flex', gap: 1 }}>
                {TransactionData && TransactionData.length > 0 && (
                  <Tooltip title="Print Check-in Articles Report" arrow>
                    <Box >
                      <IconButton
                        onClick={() => {
                          fetchCheckinArticalData().then(() => {
                            setTimeout(() => {
                              if (contentRef) {
                                handlePrint();
                              }
                            }, 500);
                          }).catch(error => {
                            console.error('Error preparing print:', error);
                            toast.error('Failed to prepare print');
                          });
                        }}
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: '#635bff',
                          color: 'white',
                          borderRadius: '7px',
                          padding: '3px 8px',
                          '&:hover': {
                            backgroundColor: '#1565c0',
                          }
                        }}
                        disabled={OpenLoader}
                      >
                        {OpenLoader ? <CircularProgress size={20} /> : <PrintIcon />}
                      </IconButton>
                    </Box>
                  </Tooltip>
                )}

                <Tooltip title="Exit" arrow>
                  <IconButton
                    onClick={handleClickCancel}
                    variant="contained"
                    size="small"
                    sx={{
                      backgroundColor: '#635bff',
                      color: 'white',
                      borderRadius: '7px',
                      padding: '3px 8px',
                      '&:hover': {
                        backgroundColor: '#1565c0',
                      }
                    }}
                  >
                    <CancelPresentationIcon />
                  </IconButton>
                </Tooltip>
              </Box>

              {TransactionData && TransactionData.length > 0 && TransactionData[0].BookSt === "L" && (
                <Tooltip title="Cancel this checkout" arrow>
                  <Box sx={{ position: 'absolute', right: 150 }}>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: "#e01c0dff",
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        height: 35,
                        borderRadius: '9px',
                        '&:hover': {
                          boxShadow: '0 5px 8px 2px rgba(255, 82, 82, .4)',
                          background: '#c52838ff'
                        },
                      }}
                      onClick={handleCheckInClick}
                    >
                      <CancelIcon sx={{ fontSize: '18px', mr: 1 }} />
                      Cancel
                    </Button>
                  </Box>
                </Tooltip>
              )}

              {TransactionData && TransactionData.length > 0 &&
                <Tooltip title="See The List" arrow>
                  <Box sx={{ position: 'absolute', right: 300 }}>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: "#635bff",
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        height: 30,
                        borderRadius: '5px',
                        '&:hover': {
                          background: '#2d68e6ff'
                        },
                      }}
                      onClick={handleCheckList}
                    >
                      Check-In Artical
                    </Button>
                  </Box>
                </Tooltip>
              }
            </Box>
            <Grid container md={12} spacing={0.5}>
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" fullWidth>
                  <OutlinedInput
                    id="outlined-adornment-weight"
                    startAdornment={
                      <InputAdornment position="start">
                        <div
                          style={{
                            width: 25,
                            height: 15,
                            backgroundImage: `url(${watch("CountryIcon")})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            borderRadius: '4px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        />
                      </InputAdornment>
                    }
                    aria-describedby="outlined-weight-helper-text"
                    placeholder={`Enter Valid  Mobile Number`}
                    style={{ width: "100%", height: 40 }}

                    value={watch('MobileNo') || ''}
                    {...register('MobileNo', { onChange: (e) => handleMobileChange(e, 'A') })}
                    inputProps={{
                      'aria-label': 'weight',
                      style: { height: 40 },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="PropName"
                  name="PropName"
                  label="Property Name"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={watch('PropName') || ''}
                  {...register('PropName')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="ResidentName"
                  name="ResidentName"
                  label="First Name"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={watch('ResidentName') || ''}
                  {...register('ResidentName')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={
                      <>
                        Actual CheckOut <span style={{ color: 'red' }}>*</span>
                      </>
                    }
                    value={
                      watch('CheckingDt')
                        ? dayjs(watch('CheckingDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])
                        : dayjs()
                    }
                    onChange={(newValue) => {
                      if (newValue) {
                        const formattedDate = newValue.format('DD/MM/YYYY');
                        setValue('CheckingDt', formattedDate);
                        setSelectedCheckoutDate(formattedDate);
                      } else {
                        setValue('CheckingDt', '');
                        setSelectedCheckoutDate('');
                      }
                    }}
                    minDate={dayjs(watch('CheckinDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])}

                    format="DD/MM/YYYY"
                    slotProps={{
                      textField: {
                        variant: 'filled',
                        fullWidth: true,
                        className: 'custom-textfield',
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="BookNo"
                  name="BookNo"
                  label="Book No"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={watch('BookNo') || ''}
                  {...register('BookNo', { onChange: (e) => handleBookNoChange(e, 'A') })}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="BookDt"
                  name="BookDt"
                  label="Book Date"
                  variant="filled"
                  // type="date"
                  fullWidth
                  className="custom-textfield"
                  value={formatDate(watch('BookDt'))}
                  {...register('BookDt')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="Duration"
                  name="Duration"
                  label="Duration"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={watch('Duration') || ''}
                  {...register('Duration')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="CheckinDt"
                  name="CheckinDt"
                  // type="date"
                  label="Checkin Date"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formatDate(watch('CheckinDt'))}
                  {...register('CheckinDt')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="BookUpToDt"
                  name="BookUpToDt"
                  label="Checkout Date"
                  // type="date"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formatDate(watch('BookUpToDt'))}
                  {...register('BookUpToDt')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={2} sx={{ display: "flex", justifyContent: { xs: 'flex-end', md: 'flex-start' }, alignItems: 'center' }}>
                <Tooltip title='Get booking details data' arrow>
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{
                      backgroundColor: "#635bff",
                      height: 35,
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      borderRadius: '9px'
                    }}
                    onClick={handleClickCheckAva}
                  >
                    Get Data
                  </Button>
                </Tooltip>
                {/* {TransactionData && TransactionData.length > 0 && TransactionData[0].BookSt === "L" && (
                  <Tooltip title='Cancel this checkout' arrow>
                    <span>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: "#e01c0dff",
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          height: 35,
                          marginX: 1,
                          borderRadius: '9px',
                          '&:hover': {
                            boxShadow: '0 5px 8px 2px rgba(255, 82, 82, .4)',
                            background: '#c52838ff'
                          },
                        }}
                        onClick={handleCheckInClick}
                      >
                        <CancelIcon sx={{ fontSize: '18px', mr: 1 }} />
                        Cancel
                      </Button>
                    </span>
                  </Tooltip>
                )} */}
              </Grid>
            </Grid>
            <hr></hr>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <Typography variant="h6" gutterBottom >
                  Room Details
                </Typography>
              </Grid>
              <Grid item xs={12} sm={10}>
                <Grid container spacing={1} >
                  <Grid item xs={6} md={2} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
                    <TextField
                      id="WingName"
                      name="WingName"
                      label="Wing"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('WingName') || ''}
                      {...register('WingName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={6} md={2} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
                    <TextField
                      id="FloorName"
                      name="FloorName"
                      label="Floor"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('FloorName') || ''}
                      {...register('FloorName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      id="RoomTypeName"
                      name="RoomTypeName"
                      label="Room Type"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('RoomTypeName') || ''}
                      {...register('RoomTypeName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      id="RoombedName"
                      name="RoombedName"
                      label="Bed No"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('RoombedName') || ''}
                      {...register('RoombedName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      id="RoomBedTypeName"
                      name="RoomBedTypeName"
                      label="Bed Type"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('RoomBedTypeName') || ''}
                      {...register('RoomBedTypeName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      id="BedRent"
                      name="BedRent"
                      label="Standard Rent"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      {...register('BedRent')}
                      value={watch('BedRent') || ''}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>
                </Grid>
                {/* </Paper> */}
              </Grid>
            </Grid>
            <hr></hr>
            <Grid container spacing={1} >
              <Grid item xs={12} sm={12}>
                <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                  <Grid item xs={12} sm={6} md={6} display="flex" alignItems="center">
                    <Typography variant="h6" gutterBottom sx={{ mr: 1 }}>
                      Booking Status:
                    </Typography>
                    {TransactionData && TransactionData.length > 0 ? (
                      <Typography
                        component="span"
                        style={{
                          color: TransactionData[0].BookSt === "C" ? "green" :
                            TransactionData[0].BookSt === "B" ? "blue" :
                              TransactionData[0].BookSt === "O" ? "orange" : "red",
                          fontWeight: "bold",
                          marginLeft: "8px"
                        }}
                      >
                        {TransactionData[0].BookSt === "C"
                          ? "Confirmed"
                          : TransactionData[0].BookSt === "B"
                            ? "Booked"
                            : TransactionData[0].BookSt === "O"
                              ? "CheckedIn"
                              : TransactionData[0].BookSt === "L"
                                ? "CheckOut"
                                : TransactionData[0].BookSt === "X"
                                  ? "Cancelled"
                                  : "Unknown"}
                      </Typography>
                    ) : (
                      <Typography variant="body1" sx={{ color: 'gray', fontWeight: 'bold' }}>
                        Not Found
                      </Typography>
                    )}
                  </Grid>

                </Grid>
              </Grid>
            </Grid>

          </Container>
          <div style={{ display: 'none' }}>
            {<BReport contentRef={contentRef} DataObj={watch()} />}
          </div>
          <ConfirmationDialog
            open={openCheckoutConfirm}
            onClose={() => setOpenCheckoutConfirm(false)}
            onConfirm={handleCheckoutConfirm}
            title="Confirm Checkout"
            message="Are you sure you want to checkout this booking?"
          />
          <ConfirmationDialog
            open={openCheckinConfirm}
            onClose={() => setOpenCheckinConfirm(false)}
            onConfirm={handleCheckinConfirm}
            title="Cancel Check-out"
            message="Are you sure you want to check-in this booking?"
          />
          {showPayAdvice && payAdvice.length > 0 && (
            <Grid container >
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    mb: 1,
                    fontSize: { xs: '0.85rem', sm: '0.95rem' },
                    fontWeight: 'bold',
                    color: '#1976d2',
                    background: 'lightgray',
                    padding: { xs: '6px 8px', sm: '8px 12px' },
                    borderRadius: '4px',
                    borderLeft: '4px solid #1976d2'
                  }}
                >
                  💰 Payment Advice Details
                </Typography>
                <TableContainer
                  component={Paper}
                  sx={{
                    maxHeight: 200,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    background: 'linear(145deg, #ffffff, #fafafa)',
                    overflowX: 'auto'
                  }}
                >
                  <Table
                    stickyHeader
                    size="small"
                    sx={{
                      minWidth: 650,
                      '& .MuiTableCell-root': {
                        padding: { xs: '2px 4px', sm: '4px 6px' },
                        border: '1px solid #e0e0e0',
                        lineHeight: '1.2'
                      },
                      '& .MuiTableHead-root .MuiTableCell-root': {
                        background: 'linear(45deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: { xs: '0.7rem', sm: '0.75rem' },
                        padding: { xs: '4px 6px', sm: '6px 8px' },
                        borderBottom: '2px solid #5a6fd8',
                        whiteSpace: 'nowrap'
                      },
                      '& .MuiTableBody-root .MuiTableCell-root': {
                        fontSize: { xs: '0.7rem', sm: '0.75rem' },
                        padding: { xs: '2px 4px', sm: '4px 6px' },
                        whiteSpace: 'nowrap'
                      },
                      '& .MuiTableRow-root': {
                        height: { xs: '28px', sm: '32px' },
                        cursor: 'pointer'
                      }
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{
                          width: { xs: '12%', sm: '10%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>AdvNo</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>AdvDt</TableCell>
                        <TableCell sx={{
                          width: { xs: '12%', sm: '10%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>AdviceFor</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="right">AdvAmt</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="right">RcdAmt</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="right">Balance</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="center">DueDays</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>RecDt</TableCell>
                        <TableCell sx={{
                          width: { xs: '14%', sm: '12%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>Remark</TableCell>
                        <TableCell sx={{
                          width: { xs: '22%', sm: '20%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {payAdvice?.map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            height: { xs: '25px', sm: '28px' },
                            '&:nth-of-type(odd)': {
                              backgroundColor: '#f8fbff'
                            },
                            '&:nth-of-type(even)': {
                              backgroundColor: '#ffffff'
                            },
                            '&:hover': {
                              backgroundColor: '#f0f7ff'
                            }
                          }}
                          onDoubleClick={() => {
                            const url = `/advicegeneratetable?PytAdvId=${item.PytAdvId}`;
                            window.open(url, '_blank');
                          }}
                        >
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            fontWeight: 'bold',
                            color: '#1565c0',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }}>
                            {item?.PytAdvNo}
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            color: '#666',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }}>
                            {moment(item?.PytAdvDt).format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }}>
                            <Chip
                              label={
                                item?.PytAdvFor === "D" ? "Deposit" :
                                  item?.PytAdvFor === "R" ? "Rent" :
                                    item?.PytAdvFor === "O" ? "Other" :
                                      item?.PytAdvFor === "T" ? "TopUp" : ""
                              }
                              size="small"
                              sx={{
                                fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                height: { xs: '16px', sm: '18px' },
                                fontWeight: 'bold',
                                backgroundColor:
                                  item?.PytAdvFor === "D" ? '#e8f5e9' :
                                    item?.PytAdvFor === "R" ? '#fff3e0' :
                                      item?.PytAdvFor === "O" ? '#f3e5f5' :
                                        '#e1f5fe',
                                color:
                                  item?.PytAdvFor === "D" ? '#2e7d32' :
                                    item?.PytAdvFor === "R" ? '#ef6c00' :
                                      item?.PytAdvFor === "O" ? '#7b1fa2' :
                                        '#0277bd'
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            fontWeight: 'bold',
                            color: '#2e7d32',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }} align="right">
                            ₹{item?.Amount}
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            fontWeight: 'bold',
                            color: '#1976d2',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }} align="right">
                            ₹{item?.RcdAmt || '0'}
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            fontWeight: 'bold',
                            color: item?.BalAmount > 0 ? '#d32f2f' : '#2e7d32',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }} align="right">
                            ₹{item?.BalAmount}
                          </TableCell>
                          <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                            <Chip
                              label={item?.DueDays}
                              size="small"
                              sx={{
                                fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                height: { xs: '16px', sm: '18px' },
                                fontWeight: 'bold',
                                color: 'white',
                                backgroundColor:
                                  item?.DueDays === 0 ? '#4caf50' :
                                    item?.DueDays <= 7 ? '#ff9800' :
                                      item?.DueDays <= 30 ? '#f44336' :
                                        '#d32f2f'
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            color: '#666',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }}>
                            {item?.RecDt ? moment(item.RecDt).format("DD-MM-YYYY") : "-"}
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            color: '#666',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }}>
                            {item?.Remark || "-"}
                          </TableCell>
                          <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                            {item?.PaymentSt && (
                              <Chip
                                label={item.PaymentSt}
                                size="small"
                                sx={{
                                  fontWeight: 'bold',
                                  color: 'white',
                                  backgroundColor:
                                    item.PaymentSt.toLowerCase() === 'paid' ? '#4CAF50' :
                                      item.PaymentSt.toLowerCase() === 'partial' ? '#FF9800' :
                                        '#F44336',
                                  marginRight: item.PaymentSt.toLowerCase() !== 'paid' ? '4px' : 0,
                                  fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                  height: { xs: '18px', sm: '20px' },
                                  boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                }}
                              />
                            )}
                            {item?.PaymentSt?.toLowerCase() !== 'paid' && (
                              <Box sx={{
                                display: 'inline-flex',
                                gap: 0.5,
                                ml: 0.5,
                                flexWrap: { xs: 'wrap', sm: 'nowrap' }
                              }}>
                                <Button
                                  variant="contained"
                                  size="small"
                                  color="primary"
                                  onClick={() => handleSendPaymentLink(item)}
                                  sx={{
                                    padding: { xs: '1px 6px', sm: '2px 8px' },
                                    minWidth: 'auto',
                                    fontSize: { xs: '0.55rem', sm: '0.6rem' },
                                    height: { xs: '20px', sm: '22px' },
                                    background: 'linear(45deg, #2196F3, #21CBF3)',
                                    boxShadow: '0 1px 3px rgba(33, 150, 243, 0.3)',
                                    '&:hover': {
                                      background: 'linear(45deg, #1976D2, #00B0FF)',
                                      boxShadow: '0 2px 5px rgba(33, 150, 243, 0.4)'
                                    }
                                  }}
                                >
                                  {loadingPaymentLinks[item.PytAdvId] ? (
                                    <CircularProgress size={10} sx={{ color: 'white' }} />
                                  ) : (
                                    '💳 Pay'
                                  )}
                                </Button>

                                <Tooltip title="Refresh Data" arrow>
                                  <IconButton
                                    size="small"
                                    onClick={() => fetchPayAdvice(BookId)}
                                    sx={{
                                      padding: '2px',
                                      '&:hover': {
                                        backgroundColor: 'rgba(255, 152, 0, 0.1)',
                                        transform: 'rotate(90deg)',
                                        transition: 'transform 0.3s ease'
                                      },
                                      height: { xs: '20px', sm: '22px' },
                                      width: { xs: '20px', sm: '22px' }
                                    }}
                                  >
                                    <RefreshIcon sx={{
                                      fontSize: { xs: '12px', sm: '14px' },
                                      color: '#FF9800',
                                      fontWeight: 'bold'
                                    }} />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          )}
        </Grid>
        <div style={{ display: 'none' }}>
          {checkinArticalData && checkinArticalData.items && (
            <CheckinArticalPrint
              contentRef={contentRef}
              items={checkinArticalData.items}
              damageStatus={damageStatus}
              damageCharges={damageCharges}
              lostCharges={lostCharges}
              remarks={remarks}
              bookingData={checkinArticalData.bookingData}
              uploadedPhotos={uploadedPhotos}
            />
          )}
        </div>

        <CheckinArtical
          open={openCheckoutList}
          onClose={() => setOpenCheckoutList(false)}
          bookId={BookId}
          roomTypeId={TransactionData[0]?.RoomTypeId}
          roomBedTypeId={TransactionData[0]?.RoomBedTypeId}
          onDataUpdate={(data) => setCheckinArticalData(data)}
        />
      </Box >
    </>
  )
}

export default Checkoutartical;